require.register("app/restaurant/show/InfoTab", function(exports, require, module){
  $0
  
});

